import { defineStore } from 'pinia'
import HistoryStorage from '../store/HistoryStorage'
import { resolveGateway } from '../utils'

export const useSearchStore = defineStore('search', {
  persist: {
    enabled: true,
    strategies: [
      {
        storage: HistoryStorage,
      },
    ],
  },
  state: () => {
    const { gateway = 'BHS', locale = 'en', utm_source, utm_medium, utm_campaign, ref_wk } = resolveGateway()
    return {
      visitorId: '',
      gateway,
      locale,
      query: '',
      orderBy: '',
      pageSize: 36,
      page: 0,
      path: [],
      onlyInStock: true,
      filters: {},
      customPriceFilter: {
        min: null,
        max: null,
      },
      utm_source,
      utm_medium,
      utm_campaign,
      ref_wk,
    }
  },
  actions: {
    resetCustomPriceFilter() {
      this.customPriceFilter = {
        min: null,
        max: null,
      }
    }
  }
})
